import { DropdownItem } from "../common";

export const TIME_ZONES: Array<DropdownItem> = [
	{ label: 'Eastern Daylight Time (GMT-4)', value: '-0400' },
	{ label: 'Central Daylight Time (GMT-5)', value: '-0500' },
	{ label: 'Mountain Daylight Time (GMT-6)', value: '-0600' },
	{ label: 'Pacific Daylight Time (GMT-7)', value: '-0700' },
	{ label: 'Alaska Daylight Time (GMT-8)', value: '-0800' },
	{ label: 'UTC', value: '+0000' }
];
